import { DateTime } from "@bps/utils";

export const toLocalTime = (dateTimeString: string | undefined) => {
  if (dateTimeString) {
    return DateTime.fromISO(dateTimeString).toFormat("D tt");
  }
};
